import { portageConfig } from "./data";
import CityPageTemplate from "../city-template/CityPageTemplate";

export default function PortagePage() {
  return <CityPageTemplate config={portageConfig} />;
}